module.exports = __webpack_public_path__ + "static/media/Picture-perfect-Web-Corporate-collage.0297bb2d.webp";